<template>
  <Modal>
    <template #title>{{ title }}</template>
    <TabBar small>
      <TabBarTab value="active">Active</TabBarTab>
      <template #content>
        <div
          class="flex flex-col-reverse overflow-y-auto"
          style="height: 20rem"
        >
          <div
            v-for="(equipment, index) in filteredEquipment"
            @click="select(equipment)"
            :key="equipment.id"
            ref="equipmentDivs"
            class="px-4 py-1 cursor-pointer hover:bg-gray-200"
            :class="{
              'bg-gray-200': isSelected(equipment) || index == currentIndex,
            }"
          >
            {{ equipment.name }}
            <div class="text-xs italic text-gray-600">
              {{ equipment.description }}
            </div>
          </div>
        </div>
      </template>
    </TabBar>
    <div class="flex flex-row items-center">
      <Textfield
        v-model="search"
        @keydown-enter="select()"
        @keydown-up="incrementIndex()"
        @keydown-down="decrementIndex()"
        :icon="$icons.SEARCH"
        autocomplete="off"
        class="w-full max-w-xs mt-2"
        has-focus
        no-validate
        no-focus-next
      >
        Search
      </Textfield>
    </div>
    <template #actions class="mx-12">
      <CloseButton @click="$modals.close" />
      <Button @click="select()" raised>Select</Button>
    </template>
  </Modal>
</template>

<script lang="ts" setup>
import { computed, PropType, Ref, ref } from 'vue'
import { useModals } from '~/plugins/modals'
import { useLoader } from '~/plugins/loader'
import { useStore } from '~/plugins/store'
import Equipment from '~/database/models/Equipment'
import Modal from '~/components/Modal.vue'
import TabBar from '~/components/TabBar.vue'
import TabBarTab from '~/components/TabBarTab.vue'
import Textfield from '~/components/Textfield.vue'
import CloseButton from '~/components/CloseButton.vue'
import Button from '~/components/Button.vue'

const props = defineProps({
  resolve: {
    type: Function as PropType<Function>,
    default: () => null,
  },
  equipment_id: {
    type: [Number, String] as PropType<string | number>,
    default: '',
  },
  status: {
    type: [Number, String] as PropType<string>,
    default: 'active',
  },
  title: {
    type: String as PropType<string>,
    defualt: 'Select Equipment',
  },
  subtitle: {
    type: String as PropType<string>,
    defualt: '',
  },
})

const currentIndex = ref(0)
const loader = useLoader()

//search
const search = ref('')

const store = useStore()
const filteredEquipment = computed(() => {
  return store.equipment.set.value.filter((item) => {
    if (!item.active) return false
    if (!search.value) return true
    const searchString = search.value.toLowerCase()
    if (item.name.toLowerCase().includes(searchString)) {
      return true
    }
    if (
      item.description &&
      item.description.toLowerCase().includes(searchString)
    ) {
      return true
    }
    return false
  })
})

//selection
const modals = useModals()
async function select(equipment: Equipment | undefined = undefined) {
  if (!equipment) equipment = filteredEquipment.value[currentIndex.value]
  props.resolve(equipment)
  modals.close()
}
function incrementIndex() {
  if (currentIndex.value == filteredEquipment.value.length - 1) {
    currentIndex.value = 0
    return
  }
  currentIndex.value++
  scrollCurrentCustomerIntoView()
}
function decrementIndex() {
  if (currentIndex.value == 0) {
    currentIndex.value = filteredEquipment.value.length - 1
    return
  }
  currentIndex.value--
  scrollCurrentCustomerIntoView()
}
const equipmentDivs: Ref<HTMLDivElement[] | undefined> = ref()
function scrollCurrentCustomerIntoView() {
  if (!equipmentDivs.value) return
  const el = equipmentDivs.value[currentIndex.value]
  if (!el) return
  el.scrollIntoView()
}
function isSelected(equipment: Equipment | { name: string; id: string }) {
  if (!props.equipment_id) return
  return equipment.id == props.equipment_id
}
</script>
